import React from "react";

export const HoursMultiplierContext = React.createContext<number>(1);
